module.exports = __webpack_public_path__ + "img/bl.5b00ddbe.svg";